import axios from '@/libs/api.request'

export const getAssembledPart = (id) => {
  return axios.request({
    url: `parts/assembled-part/${id}`,
    method: 'get'
  })
}

export const createAssembledPart = (data) => {
  return axios.request({
    url: 'parts/assembled-part/create',
    method: 'post',
    data
  })
}

export const updateAssembledPart = (id, data) => {
  return axios.request({
    url: `parts/assembled-part/${id}`,
    method: 'put',
    data
  })
}

export const getChangeLogs = (id) => {
  return axios.request({
    url: `parts/assembled-part/${id}/changes`,
    method: 'get'
  })
}
